import React from "react";
import { Form } from "antd";
import Master from "../../../imgs/mastercardlogo.svg";
import Visa from "../../../imgs/visalogo.svg";

function CreditCardModal(props) {
  return (
    <div className="accountModal-container">
      <div className="card-body">
        <div className="row m-0 justify-content-between pb-4">
          <h2 className="heading">Add new credit card</h2>
          <div>
          <img src={Master} alt="" className="pr-2" />
            <img src={Visa} alt="" />
          </div>
        </div>
        <div className="content-wrapper mt-4">
          <Form className="form">
            <div className="input-field">
              <label>Name on card</label>
              <input
                type="text"
                placeholder="Name on card"
                name="Name on card"
                // value={fullName}
                // onChange={(event) =>
                //   setPersonBountyState({
                //     ...personBountyState,
                //     [event.target.name]: event.target.value,
                //   })
                // }
              />
            </div>
            <div className="input-field">
              <label>Card number</label>
              <input
                type="text"
                placeholder="**** **** **** 1223"
                name="text"
                // value={jobTitle}
                // onChange={(event) =>
                //   setPersonBountyState({
                //     ...personBountyState,
                //     [event.target.name]: event.target.value,
                //   })
                // }
              />
            </div>
            <div className="row">
              <div className="input-field col-4">
                <label>Expire date</label>
                <input
                  type="text"
                  placeholder="11/22"
                  name="Number"
                  // value={jobTitle}
                  // onChange={(event) =>
                  //   setPersonBountyState({
                  //     ...personBountyState,
                  //     [event.target.name]: event.target.value,
                  //   })
                  // }
                />
              </div>
              <div className="input-field col-4">
                <label>CVV</label>
                <input
                  type="text"
                  placeholder="***"
                  name="Number"
                  // value={jobTitle}
                  // onChange={(event) =>
                  //   setPersonBountyState({
                  //     ...personBountyState,
                  //     [event.target.name]: event.target.value,
                  //   })
                  // }
                />
              </div>
              <div className="input-field col-4 ">
                <label>Zip code</label>
                <input
                  type="text"
                  placeholder="90120"
                  name="Number"
                  // value={jobTitle}
                  // onChange={(event) =>
                  //   setPersonBountyState({
                  //     ...personBountyState,
                  //     [event.target.name]: event.target.value,
                  //   })
                  // }
                />
              </div>
            </div>
          </Form>
        </div>
        <div className="row d-flex signup-with mt-4">
          <div className="col-6">
            <button className="cancel" style={{ backgroundColor: "$input-bg" }} onClick={props.handleCancel} >
              Cancel
            </button>
          </div>
          <div className="col-6">
            <button  className="intro">Add card
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreditCardModal;

// import React from "react";
// import Visa from "../../../imgs/visalogo.svg";
// import Master from "../../../imgs/mastercardlogo.svg";
// import { PostIcon } from "../SvgIcons/SvgIcons";
// import

// function CreditCardModal() {
//   return (
//     <div className="bounty-modal-wrapper">
//       <div className="feed-card-wrapper">
//         <div className="row m-0 justify-content-between ">
//           <h2 className="heading pt-4">Add new credit card</h2>
//           <div className="pt-4">
//             <img src={Visa} alt="" />
//             <img src={Master} alt="" />
//           </div>
//         </div>
//       </div>
//       <Form className="form">
//         <div className="form-details">
//           <div className="input-field">
//             <label>Name on card</label>
//             <input
//               type="text"
//               placeholder="Name on card"
//               name="Name on card"
//               // value={fullName}
//               // onChange={(event) =>
//               //   setPersonBountyState({
//               //     ...personBountyState,
//               //     [event.target.name]: event.target.value,
//               //   })
//               // }
//             />
//           </div>
//           <div className="input-field">
//             <label>Card number</label>
//             <input
//               type="Number"
//               placeholder="**** **** **** 1223"
//               name="Number"
//               // value={jobTitle}
//               // onChange={(event) =>
//               //   setPersonBountyState({
//               //     ...personBountyState,
//               //     [event.target.name]: event.target.value,
//               //   })
//               // }
//             />
//           </div>
//           <div className="row">
//             <div className="input-field col-4">
//               <label>Card number</label>
//               <input
//                 type="Number"
//                 placeholder="**** **** **** 1223"
//                 name="Number"
//                 // value={jobTitle}
//                 // onChange={(event) =>
//                 //   setPersonBountyState({
//                 //     ...personBountyState,
//                 //     [event.target.name]: event.target.value,
//                 //   })
//                 // }
//               />
//             </div>
//             <div className="input-field col-4">
//               <label>Card number</label>
//               <input
//                 type="Number"
//                 placeholder="**** **** **** 1223"
//                 name="Number"
//                 // value={jobTitle}
//                 // onChange={(event) =>
//                 //   setPersonBountyState({
//                 //     ...personBountyState,
//                 //     [event.target.name]: event.target.value,
//                 //   })
//                 // }
//               />
//             </div>
//             <div className="input-field col-4 ">
//               <label>Card number</label>
//               <input
//                 type="Number"
//                 placeholder="**** **** **** 1223"
//                 name="Number"
//                 // value={jobTitle}
//                 // onChange={(event) =>
//                 //   setPersonBountyState({
//                 //     ...personBountyState,
//                 //     [event.target.name]: event.target.value,
//                 //   })
//                 // }
//               />
//             </div>
//           </div>
//           <button className="btn-style">
//             <PostIcon />
//             Post bounty
//           </button>
//         </div>
//       </Form>
//     </div>
//   );
// }

// export default CreditCardModal;
